module.exports = __webpack_public_path__ + "static/media/idontmind.78cbe49a.md";